import { CommonModule, DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '@bca-shared/shared.module';
import { ChooseBirthDateComponent } from '@bca-user-data/user-data/choose-birth-date/choose-birth-date.component';
import { ChooseCountryComponent } from '@bca-user-data/user-data/choose-country/choose-country.component';
import { ChooseImageComponent } from '@bca-user-data/user-data/choose-image/choose-image.component';
import { ImageUploadDialog } from '@bca-user-data/user-data/choose-image/image-upload/image-upload-dialog';
import { ImageUploadComponent } from '@bca-user-data/user-data/choose-image/image-upload/image-upload.component';
import { ResultUploadComponent } from '@bca-user-data/user-data/choose-image/image-upload/result-upload/result-upload.component';
import { StartUploadComponent } from '@bca-user-data/user-data/choose-image/image-upload/start-upload/start-upload.component';
import { UseProductComponent } from '@bca-user-data/user-data/use-product/use-product.component';
import { UserAddressComponent } from '@bca-user-data/user-data/user-address/user-address.component';
import { UserDataComponent } from '@bca-user-data/user-data/user-data.component';
import { TranslateModule } from '@ngx-translate/core';

const dialogs = [ImageUploadDialog];

@NgModule({
  declarations: [
    UserDataComponent,
    ChooseBirthDateComponent,
    ChooseCountryComponent,
    UserAddressComponent,
    UseProductComponent,
    ChooseImageComponent,
    ImageUploadComponent,
    StartUploadComponent,
    ResultUploadComponent,
    ...dialogs
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule.forChild()
  ],
  providers: [DatePipe],
  exports: [UserDataComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UserDataModule {}
